import React, { memo } from "react";
import _ from "lodash";
import { View, Row, Col } from "components/Shared";
import { translate } from "lib";
import TenancyTab from "components/Projects/Show/TenancyTab";
import PropertyPanel from "components/Projects/Show/PropertyPanel";

interface Props {
	tenancyIds: (string | number)[];
	propertyId: string | number;
	editable?: boolean;
	name?: string;
	icon?: string;
	link?: string;
}

// All tenancies of a project share the same property, so the layout is a single
// two-column Row: the left column lists every tenancy, and the right column
// renders the property + map panel ONCE (see PropertyPanel).
const TenanciesTab = ({ tenancyIds, propertyId, link }: Props) => {
	if (_.isEmpty(tenancyIds)) {
		return <View>{translate("no_tenancies")}</View>;
	}
	return (
		<View>
			<Row>
				<Col>
					{_.map(tenancyIds, (tenancyId, index) => (
						<React.Fragment key={`tenancy-${tenancyId}`}>
							{index > 0 && <hr style={{ margin: "1.5rem 0" }} />}
							<TenancyTab tenancyId={tenancyId} />
						</React.Fragment>
					))}
				</Col>
				<Col>
					<PropertyPanel propertyId={propertyId} link={link} />
				</Col>
			</Row>
		</View>
	);
};

export default memo(TenanciesTab);
